import createLucideIcon from '../createLucideIcon';

const Pencil = createLucideIcon('Pencil', [
  ['line', { x1: '18', x2: '22', y1: '2', y2: '6', key: '1e96e7' }],
  ['path', { d: 'M7.5 20.5 19 9l-4-4L3.5 16.5 2 22z', key: '12iwkt' }],
]);

export default Pencil;
